export AddResource from './AddResource';
export Resources from './Resources';
export EditResource from './EditResource';


// WEBPACK FOOTER //
// ./src/modules/resources/containers/index.js